export default __webpack_public_path__ + "media/images/logo/vk_b-5069ded06a6c6f28a2dc0bb7c124c6b3.svg";